<section class="project-tab-section">
  <div class="project-tab-section__toolbar">
    <div class="project-tab-section__intro">
      <h2 class="project-tab-section__title">Agents</h2>
      <p class="project-tab-section__subtitle">
        Bots configured for this project. Select an agent to open it in Agents.
      </p>
    </div>
    @if (projectBots.length) {
      <button mat-stroked-button color="primary" type="button" (click)="openAllBotsListModal()">
        Edit project agents
      </button>
    }
  </div>

  @if (projectBots.length) {
    <ul class="project-bot-list">
      @for (bot of projectBots; track bot._id) {
        <li>
          <button type="button" class="project-bot-list__item" (click)="navigateToBot(bot._id)">
            <mat-icon class="project-bot-list__icon" svgIcon="logo-mark" aria-hidden="true" />
            <span class="project-bot-list__name">{{ bot.name }}</span>
            <mat-icon class="project-bot-list__chevron" fontSet="material-symbols-outlined">chevron_right</mat-icon>
          </button>
        </li>
      }
    </ul>
  } @else {
    <div class="project-tab-empty">
      <mat-icon class="project-tab-empty__icon" svgIcon="logo-mark" aria-hidden="true" />
      <p class="project-tab-empty__text">
        No agents are assigned to this project yet. Add bots to enable guided conversations.
      </p>
      <button mat-flat-button color="primary" type="button" (click)="openAllBotsListModal()">
        Add project agents
      </button>
    </div>
  }
</section>
